import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { FilterButton } from 'src/components/FilterButton/FilterButton';
import { getRooms, getRoomsFiltersCount } from 'src/store/rooms/selectors';
import { sidesheetActions } from 'src/store/sidesheet/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export const RoomBookingFilterButton: FC = () => {
  const dispatch = useAppDispatch();
  const filtersCount = useSelector(getRoomsFiltersCount);
  const hasItemsToFilter = !!useSelector(getRooms).size;

  const open = useCallback(() => {
    dispatch(sidesheetActions.open('roomsFilters'));
  }, [dispatch]);

  return (
    <FilterButton
      onClick={open}
      filtersCount={filtersCount}
      disabled={!hasItemsToFilter}
      testId='roomBookingFilterButton'
    />
  );
};
